import { site } from "../config/site";

const formatter = new Intl.NumberFormat(site.locale, {
  style: "currency",
  currency: site.currencyCode
});

export function formatGbp(amount: number): string {
  return formatter.format(amount);
}
